import { Box } from '@chakra-ui/react';

const ContentPanel = ({ children, ...props }) => (
  <Box mx="auto" px="15px">
    <Box p="0 15px" minHeight="calc(100vh - 123px)" height="calc(100vh - 123px)" {...props}>
      {children}
    </Box>
  </Box>
);

export default ContentPanel;
